// frontend/src/components/MarketTicker.jsx
// ============================================================
// ⚡ MarketTicker.jsx — Ticker de prix de marché avec mise en évidence d'ENTQ
// ============================================================
import React, { useEffect, useState } from "react";

// Helper color
const getChangeColor = (val) => {
    if (val > 0) return "#4caf50";
    if (val < 0) return "#f44336";
    return "#888";
};

export default function MarketTicker() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();
        let isMounted = true;

        const fetchPrices = async () => {
            try {
                const res = await fetch("/api/oracle/market-prices", { signal: controller.signal });
                const json = await res.json();
                if (isMounted && Array.isArray(json)) {
                    setData(json);
                }
                if (isMounted) setLoading(false);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Ticker fetch error", err);
                }
            }
        };

        fetchPrices();
        const interval = setInterval(fetchPrices, 10000); // 10s refresh
        return () => {
            isMounted = false;
            controller.abort();
            clearInterval(interval);
        };
    }, []);

    if (loading) return null;

    return (
        <div className="market-ticker crypto-ticker">
            <div className="ticker-track">
                {data.map((item) => (
                    <div
                        key={item.symbol}
                        className={`ticker-item ${item.is_entq ? "entq-highlight" : ""}`}
                        style={{
                            borderRight: "1px solid #333",
                            padding: "0 15px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            opacity: item.is_entq ? 1 : 0.8
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span className="symbol" style={{ fontWeight: "bold", color: item.is_entq ? "#0ff" : "#ddd" }}>
                                {item.symbol}
                            </span>
                            <span className="price" style={{ color: "#fff", fontWeight: "500" }}>
                                ${item.price_usd?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: item.is_entq ? 4 : 2 })}
                            </span>
                            {/* Trend Indicator: Si le prix est sous l'objectif (Raw Price), signal d'achat/hausse */}
                            {item.is_entq && item.price_usd < item.target_price_usd && (
                                <span title="Bullish Trend: Price below Target" style={{ cursor: "help", fontSize: "1.2rem" }}>
                                    ↗️
                                </span>
                            )}
                        </div>
                        {item.is_entq && (
                            <small style={{ fontSize: "0.7rem", color: "#0ff", opacity: 0.7 }}>
                                Entropy: {item.entropy_index} μ
                            </small>
                        )}
                    </div>
                ))}
                {/* Clone for scroll effect if we want animation, but static for now is safer */}
            </div>

            <style>{`
        .market-ticker {
          background: #0b0b0b;
          border-bottom: 1px solid #222;
          height: 48px;
          display: flex;
          align-items: center;
          font-family: 'Roboto Mono', monospace;
          font-size: 0.85rem;
          overflow-x: auto;
          white-space: nowrap;
          padding: 0 10px;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }
        
        .market-ticker::-webkit-scrollbar {
            display: none;
        }

        .ticker-track {
          display: flex;
        }

        .entq-highlight {
           background: rgba(0, 255, 255, 0.05);
           border-bottom: 2px solid #0ff;
           height: 100%;
        }
      `}</style>
        </div>
    );
}
